"use strict";
// ApkUpdateResponse — response shape for GET /api/v1/players/me/apk-update.
//
// FS §4.7: the Android wrapper polls this endpoint with its currently
// installed version; the server replies with whether a newer APK is
// available and, if so, the verified download URL + SHA-256 + i18n
// release notes. The PWA is unaffected — this is consumed by the
// native UpdateChecker (P3 W3 T11).
//
// Field semantics:
//   - has_update: true when LATEST_APK.version !== current_version.
//   - latest_version: the server's currently published APK version
//     (semver string; not strictly validated as semver here — the
//     server is source-of-truth).
//   - download_url: non-null only when has_update is true.
//   - sha256: 64-hex-char lowercase digest of the unsigned/signed APK
//     bytes (the wrapper recomputes + asserts on download).
//   - release_notes_i18n: { fr, en } user-facing copy; null when no
//     update.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApkUpdateResponse = void 0;
const zod_1 = require("zod");
exports.ApkUpdateResponse = zod_1.z.object({
    has_update: zod_1.z.boolean(),
    latest_version: zod_1.z.string(),
    download_url: zod_1.z.string().url().nullable(),
    sha256: zod_1.z.string().regex(/^[0-9a-f]{64}$/).nullable(),
    release_notes_i18n: zod_1.z.object({ fr: zod_1.z.string(), en: zod_1.z.string() }).nullable(),
});
//# sourceMappingURL=apk-update.schema.js.map